import { SeasonPicksScreen } from '../../../../components/competitions/SeasonPicks/SeasonPicksScreen';

export default function CompetitionPicksScreen() {
  return <SeasonPicksScreen />;
}
